// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.insights.`data`.sources.network

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import one.healthium.insights.`data`.dto.ContentScreenDto

@OptIn(InternalKtorfitApi::class)
internal class _ContentApiClientImpl(
  private val _ktorfit: Ktorfit,
) : ContentApiClient {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override suspend fun getScreenModel(categoryId: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "view_models/${"$categoryId".encodeURLPath()}.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<ContentScreenDto>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun getInsight(insightId: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "insights/${"$insightId".encodeURLPath()}.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<ContentScreenDto>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun getMealPlan(id: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "mealplans/${"$id".encodeURLPath()}.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<ContentScreenDto>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun getWorkoutsScreen(): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "view_models/workouts.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<ContentScreenDto>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun getWorkout(id: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "workouts/${"$id".encodeURLPath()}.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<ContentScreenDto>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun getRecipe(id: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "recipes/${"$id".encodeURLPath()}.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<ContentScreenDto>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

internal class _ContentApiClientProvider : ClassProvider<ContentApiClient> {
  override fun create(_ktorfit: Ktorfit): ContentApiClient = _ContentApiClientImpl(_ktorfit)
}

internal fun Ktorfit.createContentApiClient(): ContentApiClient = _ContentApiClientImpl(this)
